import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { ABOUT } from '@/components/landing/about/data'

import {
    ARC,
    IconTile,
    PixelPanel,
    StageTitle
} from '@/components/generals/arcade'

const HouseRules: FC = (): ReactNode => {
    return (
        <section id='house-rules' className={ARC.section} aria-labelledby='house-rules-title'>
            <StageTitle stage="Stage 02" title="House rules" id='house-rules-title' intro={ABOUT.rulesIntro} />

            <ul className='m-0 grid list-none gap-7 p-0 lg:grid-cols-3'>
                {ABOUT.rules.map((rule, i) => (
                    <li key={rule.title} className='flex min-w-0'>
                        <PixelPanel size='sm' className='min-w-0 flex-1'>
                            <article className='flex h-full flex-col gap-4 p-6 md:p-7'>
                                <div className='flex items-center justify-between gap-3'>
                                    <IconTile name={rule.icon} tone={rule.tone} />
                                    <span className={cn(ARC.label, 'opacity-75')}>Rule {String(i + 1).padStart(2, '0')}</span>
                                </div>
                                <h3 className={cn(ARC.h3, 'mt-1')}>{rule.title}</h3>
                                <p className={ARC.text}>{rule.body}</p>
                            </article>
                        </PixelPanel>
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default HouseRules
